import React from "react";

export default function LogoMark({ size = 30, title = "Company logo" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label={title}
      focusable="false"
    >
      {/* Building body: themeable + slightly more contrast */}
      <rect
        x="16"
        y="8"
        width="32"
        height="48"
        rx="6"
        fill="currentColor"
        opacity="0.34"                 // ↑ from 0.30
        stroke="currentColor"          // subtle outline helps on neutral-10
        strokeOpacity="0.25"
        strokeWidth="1"
      />

      {/* Windows: still themeable but readable */}
      <g fill="currentColor" opacity="0.85">  {/* ↑ from 0.80 */}
        <rect x="22" y="16" width="6" height="6" rx="1.7" />
        <rect x="36" y="16" width="6" height="6" rx="1.7" />
        <rect x="22" y="28" width="6" height="6" rx="1.7" />
      </g>

      {/* Droplet: fixed brand accent so it pops */}
      <path
        d="M39 30s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z"
        fill="var(--amplify-colors-teal-60)"
      />

      {/* Highlight */}
      <path
        d="M36.5 41c1 3 3.5 5 6.5 5"
        stroke="rgba(255,255,255,0.8)"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
